let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9RY0k")).then(() => parcelRequire('cKcai'));